module.exports = __webpack_public_path__ + "static/media/1914409_1150872524529_5365494_n.9a6815ab.jpg";